// 配置全局接口域名
const baseUrl = 'https://dapi.hamdam.biz/';
const apiUrl = 'https://dapi.hamdam.biz/api/';

// Nurdala
// const baseUrl = 'https://nurdala-api.hamdam.biz/';
// const apiUrl = 'https://nurdala-api.hamdam.biz/api/';

// const baseUrl = 'https://class-api.hamdam.biz/';
// const apiUrl = 'https://class-api.hamdam.biz/api/';

// const baseUrl = 'https://mihir-api.hamdam.biz/';
// const apiUrl = 'https://mihir-api.hamdam.biz/api/';

export default {
 baseUrl: baseUrl,
 apiUrl: apiUrl,
 imgActionUrl: apiUrl + 'common/files/image'
}